import { ICategoryType, IHobbyPricing, ISkillPricing, ISubjectsPricing } from '@wot/typings';
import xhr from '../utils/fetch';

export interface PricingReqBody {
  _id?: string;
  type: ICategoryType;
  pricing: ISubjectsPricing | IHobbyPricing | ISkillPricing;
}

const savePricing = async (pricing: PricingReqBody) => {
  return await xhr({
    url: `/a/pricing`,
    method: 'POST',
    body: pricing
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const updatePricing = async (pricing: PricingReqBody) => {
  return await xhr({
    url: `/a/pricing`,
    method: 'PUT',
    body: pricing
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getPricing = async (type: string) => {
  return await xhr({
    url: `/pricing`,
    method: 'GET',
    params: {
      type
    }
  })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const pricingApi = {
  savePricing,
  getPricing,
  updatePricing
};

export default pricingApi;
